import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "First week",
  "description": "",
  "published": "2007-10-07T00:00:00.000Z",
  "redirect_from": ["/blog/first-week/swizec/148"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`There we go, the first week and weekend of student living are finally over. I can see right away that there is much I will have to get accustomed to and even more I will have to forget. Classes aren't mandatory anymore and they aren't strictly in the morning, in fact they are strictly at the most importune moment in the day. Somewhere smack in the middle where they cause more logistical problems than they solve.`}</p>
    <p>{`Organising enough work a week and not skipping classes is going to give me a tough time for quite a while until I figure out the perfect schedule for my day. Especially as I have to make sure I stay fit and healthy every single day. Luckily the night is long so I'll have time to work on schoolwork and personal projects then. At least there's that.`}</p>
    <p>{`A few days ago, Thursday if memory serves, my free copy of`}<a parentName="p" {...{
        "href": "http://steampunkmagazine.com/"
      }}>{` Steampunk Magazine`}</a>{` came to my mailbox and it was an exquisite delight. Never before have I received a free copy of a magazine because my writing was in it. Sadly, however, I still haven't quite had the time to give it a proper, or even improper, read. If it's anything like the first two issues were then I'm sure it's just perfect and a damn good read. Feels like it's getting thicker with every issue though.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      